module.exports = __webpack_public_path__ + "static/media/bo.17f983d2.png";